import {
	createStyles,
	makeStyles,
} from '@mui/styles';
import {
	Theme,
} from '@mui/material/styles';
import {
	BreakpointWidth,
} from '@app/enumerations';

const useStyles = makeStyles((theme: Theme) => {
	return createStyles({
		administrationSideBar_container: {
			display: 'flex',
			flexDirection: 'column',
			minWidth: theme.spacing(40),
			minHeight: theme.spacing(0),
			height: '100%',
			[theme.breakpoints.up(BreakpointWidth.LARGE)]: {
				borderRight: `3px solid ${theme.palette.grey[400]}`,
				width: theme.spacing(45),
			},
			[theme.breakpoints.down(BreakpointWidth.LARGE)]: {
				width: theme.spacing(40),
			},
		},
		administrationSideBar_containerMonitor: {
			[theme.breakpoints.down(BreakpointWidth.LARGE)]: {
				display: 'none',
			},
		},
		administrationSideBar_containerMobile: {
			zIndex: `${theme.zIndex.drawer} !important` as any,
			[theme.breakpoints.up(BreakpointWidth.LARGE)]: {
				display: 'none',
			},
		},
		administrationSideBar_drawerHeader: {
			display: 'flex',
			justifyContent: 'flex-end',
		},
		administrationSideBar_drawerChevronButton: {
			color: theme.palette.info.main,
		},
		administrationSideBar_dividerRoot: {

		},
	});
});

export default useStyles;